<div class="py-3 info-list " [ngClass]="{ freemium: isFreemium }">
  <app-app-info-list-item [label]="'Adult Content'"
                          [type]="'risk'"
                          [canRouteToDiscovery]="isDomainSearchEnabled"
                          [discoveryRouteLink]="['/discovery/domains/list', device, region, 'F']"
                          [discoveryQueryParams]="{'adultContentRating' : getRating(data?.brandSafety?.adultContentRating)}"
                          [value]="data?.brandSafety?.adultContentRating"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Alcohol Content'"
                          [type]="'risk'"
                          [canRouteToDiscovery]="isDomainSearchEnabled"
                          [discoveryRouteLink]="['/discovery/domains/list', device, region, 'F']"
                          [discoveryQueryParams]="{'alcoholContentRating' : getRating(data?.brandSafety?.alcoholContentRating)}"
                          [value]="data?.brandSafety?.alcoholContentRating"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Drug Content'"
                          [type]="'risk'"
                          [canRouteToDiscovery]="isDomainSearchEnabled"
                          [discoveryRouteLink]="['/discovery/domains/list', device, region, 'F']"
                          [discoveryQueryParams]="{'drugContentRating' : getRating(data?.brandSafety?.drugsContentRating)}"
                          [value]="data?.brandSafety?.drugsContentRating"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Hate Speech'"
                          [type]="'risk'"
                          [canRouteToDiscovery]="isDomainSearchEnabled"
                          [discoveryRouteLink]="['/discovery/domains/list', device, region, 'F']"
                          [discoveryQueryParams]="{'numberOfHateSpeechWordsRating' : getRating(data?.brandSafety?.numberOfHateSpeechWordsRating)}"
                          [value]="data?.brandSafety?.numberOfHateSpeechWordsRating"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Phishing'"
                          [type]="'risk'"
                          [value]="data?.brandSafety?.isPhishingRating"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Malware'"
                          [type]="'risk'"
                          [value]="data?.brandSafety?.isMalwareRating"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
</div>
